import React from "react";
import { Drawer as MuiDrawer, IconButton, Typography, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import tokens from "../designTokens";

const useStyles = makeStyles({
  head: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "16px 20px",
    borderBottom: `1px solid ${tokens.divider}`,
  },
  title: { fontFamily: tokens.fontHeading, fontWeight: 600, fontSize: 17, color: tokens.textPrimary, minWidth: 0 },
  body: { flex: 1, padding: 20, overflowY: "auto" },
  foot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 10,
    padding: "12px 20px",
    borderTop: `1px solid ${tokens.divider}`,
  },
});

// Right-edge slide-over panel on MUI Drawer.
export default function Drawer({ open, title, children, footer, onClose, width = 560 }) {
  const classes = useStyles();
  return (
    <MuiDrawer anchor="right" open={!!open} onClose={onClose} PaperProps={{ style: { width, maxWidth: "100%" } }}>
      <div className={classes.head}>
        <Typography component="div" className={classes.title}>{title}</Typography>
        <IconButton size="small" aria-label="Close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
      <div className={classes.body}>{children}</div>
      {footer && <div className={classes.foot}>{footer}</div>}
    </MuiDrawer>
  );
}
